const Program = require('./Program');
const Seat = require('./Seat');

class Classroom {
  constructor() {
    this.init();
  }

  init() {
    this.classroom_id = undefined;
    this.age_group_id = undefined;
    this.name = undefined;
    this.budgeted_capacity = undefined;

    // Inherited properties
    this.list_id = undefined;
    this.provider_id = undefined;
    this.provider_name = undefined;
    this.center_id = undefined;
    this.center_name = undefined;
    this.min_age = undefined;
    this.max_age = undefined;
    this.min_age_weeks = undefined;
    this.age_as_of = undefined;
    this.seats = [];
    this.programs = undefined;
  }

  copy() {
    const cp = new Classroom();

    cp.classroom_id = this.classroom_id;
    cp.age_group_id = this.age_group_id;
    cp.name = this.name;
    cp.budgeted_capacity = this.budgeted_capacity;

    cp.list_id = this.list_id;
    cp.provider_id = this.provider_id;
    cp.provider_name = this.provider_name;
    cp.center_id = this.center_id;
    cp.center_name = this.center_name;
    cp.min_age = this.min_age;
    cp.max_age = this.max_age;
    cp.min_age_weeks = this.min_age_weeks;
    cp.age_as_of = this.age_as_of;

    this.seats.forEach((s) => {
      cp.seats.push(s.copy());
    });

    if (this.programs) {
      cp.programs = [];
      this.programs.forEach((p) => {
        cp.programs.push(p.copy());
      })
    }
    return cp;
  }

  buildFromJSON(obj) {
    this.init();
    if (obj) {
      this.classroom_id = obj.classroom_id ? obj.classroom_id.toString() : undefined;
      this.age_group_id = obj.age_group_id ? obj.age_group_id.toString() : undefined;
      this.name = obj.name ? obj.name : undefined;
      this.budgeted_capacity = obj.budgeted_capacity ? obj.budgeted_capacity : undefined;

      this.list_id = obj.list_id ? obj.list_id.toString() : undefined;
      this.provider_id = obj.provider_id ? obj.provider_id.toString() : undefined;
      this.provider_name = obj.provider_name ? obj.provider_name : undefined;
      this.center_id = obj.center_id ? obj.center_id.toString() : undefined;
      this.center_name = obj.center_name ? obj.center_name : undefined;
      this.min_age = obj.min_age ? obj.min_age : undefined;
      this.max_age = obj.max_age ? obj.max_age : undefined;
      this.min_age_weeks = (obj.min_age_weeks === undefined) || (obj.min_age_weeks === null)
        ? undefined : obj.min_age_weeks;
      this.age_as_of = obj.age_as_of ? obj.age_as_of : undefined;

      this.seats = [];
      if (obj.seats) {
        obj.seats.forEach((s) => {
          const seat = new Seat();
          seat.buildFromJSON(s);
          this.seats.push(seat);
        });
      }
      if (obj.programs) {
        this.programs = [];
        obj.programs.forEach((p) => {
          const program = new Program();
          program.buildFromJSON(p);
          this.programs.push(program);
        });
      }
    }
  }

  toString() {
    let result = this.name ? this.name : '';
    return result;
  }

  getId() {
    return this.classroom_id;
  }

  setId(classroom_id) {
    this.classroom_id = classroom_id ? classroom_id.toString() : undefined;
  }
  
  getAgeGroupId() {
    return this.age_group_id;
  }

  setAgeGroupId(age_group_id) {
    this.age_group_id = age_group_id ? age_group_id.toString() : undefined;
  }

  getName() {
    return this.name;
  }

  setName(name) {
    this.name = name;
  }

  getBudgetedCapacity() {
    return this.budgeted_capacity;
  }

  setBudgetedCapacity(budgeted_capacity) {
    this.budgeted_capacity = budgeted_capacity;
  }

  getSeats() {
    return this.seats;
  }

  setSeats(seats) {
    this.seats = [];
    if (seats) {
      seats.forEach(s => {
        this.seats.push(s.copy());
      });
    }
  }

  // Read only properties
  getListId() {
    return this.list_id;
  }

  getProviderId() {
    return this.provider_id;
  }

  getProviderName() {
    return this.provider_name;
  }
  
  getCenterId() {
    return this.center_id;
  }

  getCenterName() {
    return this.center_name;
  }
  
  getMinAge() {
    return this.min_age;
  }

  getMaxAge() {
    return this.max_age;
  }
  
  getMinAgeWeeks() {
    return this.min_age_weeks;
  }

  getAgeAsOf() {
    if (!this.age_as_of) {
      return undefined;
    }

    // Convert this into a UTC date, ensuring this date is in the past year
    // If age_as_of includes a year, we'll pull the year from this variable
    const month = Math.floor((this.age_as_of % 10000) / 100) - 1;
    const day = this.age_as_of % 100;
    const now = new Date();
    let year;
    
    if (this.age_as_of > 10000) {
      year = Math.floor(this.age_as_of / 10000);
    } else {
      year = now.getUTCFullYear();
      if ((now.getUTCMonth() < month) || ((now.getUTCMonth() === month) && (now.getUTCDate() < day))) {
        year--;
      }
    }
    const date = new Date(Date.UTC(year, month, day));
    return date;
  }

  getAgeAsOfFixed() {
    if (!this.age_as_of) {
      return undefined;
    }

    return (this.age_as_of > 10000);
  }
  
  getPrograms() {
    return this.programs;
  }
}

module.exports = Classroom;
